import React from 'react'
import arrayMutators from 'final-form-arrays'
import { Field, Form } from 'react-final-form'
import FormTextField from '../../../../../components/fields/FormTextField'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../../components/button/Button'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { PersonalPrelevementInfoModel } from '../../../profileModel'
import { useMediaQuery } from 'react-responsive'
import FormPhoneField from '../../../../../components/fields/FormPhoneField'
import FormAutocompleteField from '../../../../../components/fields/FormAutocompleteField'
import suggestEmail from '../../../../../api/suggestEmail'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            formStyle: {
                marginBottom: 20
            },
            inputStyle: {
                marginBottom: 20
            },
            buttonContainerStyle: {
                marginTop: 50
            },
            error: {
                color: 'red'
            }
        }
    )
)

interface AcceptingProps {
    error?: string,
    initialValues: PersonalPrelevementInfoModel,
    onSubmit: (values: PersonalPrelevementInfoModel) => void,
    validate: (values: PersonalPrelevementInfoModel) => any
}

type PrelevementPersonalInfoFormProps = AcceptingProps

const PrelevementPersonalInfoForm: React.FC<PrelevementPersonalInfoFormProps> = (
    {
        error,
        initialValues,
        onSubmit,
        validate
    }
) => {
    const classes = useStyle()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
    const buttonContainerClass: ClassValue = classNames(
        'col-xs-12',
        classes.buttonContainerStyle
    )

    const smsTextClass : ClassValue = classNames(
        'col-xs-12',
        classes.colorBlue,
        isLargeScreen? classes.text8 : classes.text14
    )

    return (
        <Form
            mutators={{
                ...arrayMutators
            }}
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={
                (
                    {
                        handleSubmit
                    }
                ) => (
                    <form
                        onSubmit={handleSubmit}
                        className={classNames('row', classes.formStyle)}
                    >
                        <div className={classNames('col-xs-6', classes.inputStyle)}>
                            <Field
                                name="lastname"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.lastname',
                                    defaultMessage: 'Nom',
                                    description: 'Lastname placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-6', classes.inputStyle)}>
                            <Field
                                name="firstname"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.firstname',
                                    defaultMessage: 'Prénom',
                                    description: 'Firstname placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-12', classes.inputStyle)}>
                            <Field
                                name="street"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.street',
                                    defaultMessage: 'N° et rue',
                                    description: 'Address placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-4', classes.inputStyle)}>
                            <Field
                                name="postalCode"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.postalCode',
                                    defaultMessage: 'Code postal',
                                    description: 'Postal code placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-4', classes.inputStyle)}>
                            <Field
                                name="city"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.city',
                                    defaultMessage: 'Ville',
                                    description: 'City placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-4', classes.inputStyle)}>
                            <Field
                                name="country"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.country',
                                    defaultMessage: 'Pays',
                                    description: 'Country placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-8', classes.inputStyle)}>
                            <Field
                                name="email"
                                component={FormAutocompleteField}
                                fetchOptions={(param: string) => suggestEmail(param)}
                                placeholder={{
                                    id: 'profile.prelevement.step1.email',
                                    defaultMessage: 'Courriel',
                                    description: 'Email placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-8 col-sm-4', classes.inputStyle)}>
                            <Field
                                name="phone"
                                component={FormPhoneField}
                                placeholder={{
                                    id: 'profile.prelevement.step1.phone',
                                    defaultMessage: 'Téléphone',
                                    description: 'Phone placeholder'
                                }}
                            />
                        </div>
                        <span className={smsTextClass}>
                            <FormattedMessage
                                id="profile.prelevement.step1.sms"
                                defaultMessage="Un SMS vous sera envoyé lors de la signature électronique du document"
                                description="Sms will be sent text"
                            />
                        </span>
                        {error && <div className="col-xs-12"><span className={classes.error}>{error}</span></div>}

                        <div className={buttonContainerClass}>
                            <div className="col-xs-12 col-md-4">
                                <Button
                                    background="backgroundAccessibility"
                                    color="colorWhite"
                                    textStyle="text8"
                                    type="submit"
                                    size="bigButton"
                                >
                                    <FormattedMessage
                                        id="global.btn.next"
                                        defaultMessage="Suivant"
                                        description="Next"
                                    />
                                </Button>
                            </div>
                        </div>
                    </form>
                )
            }
        />
    )
}

export default PrelevementPersonalInfoForm
